var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create-manual-transaction-modal',{attrs:{"dialog":_vm.dialog},on:{"handleChangeDialog":_vm.handleChangeDialog,"handleSave":_vm.handleCreateTransaction}})}
var staticRenderFns = []

export { render, staticRenderFns }